import React from 'react'

import { allFileTypes } from '@/utils/constants'
import { Controller } from 'react-hook-form'
import FieldWrapper from '../FieldWrapper'

const SimpleFileInput = ({ name, disabled, isRequired = true, isMultiple = false, ...rest }) => {
  return (
    <Controller
      name={name}
      defaultValue={[]}
      render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => {
        return (
          <FieldWrapper name={name} error={error} isRequired={isRequired} {...rest}>
            <input
              type="file"
              id={name}
              accept={allFileTypes}
              name={name}
              multiple={isMultiple}
              onChange={(event) => {
                onChange(event.target.files)
              }}
              onBlur={onBlur}
              ref={ref}
              disabled={disabled}
              style={{ width: '100%' }}
            />
          </FieldWrapper>
        )
      }}
    />
  )
}

export default SimpleFileInput
